import { actions } from "./action-list";

export function ondcReportUploadFailure(value) {
  return {
    type: actions.ONDC_UPLOAD_FAILURE,
    value,
  };
}

export function ondcReportUpload(value) {
  return {
    type: actions.ONDC_UPLOAD,
    value,
  };
}
